"use strict";
export default function regexp$config(options) {
    if (!options.regexp) throw new Error('Missing required "regexp" option for "regexp" validator');

    options = {
        type: 'regexp',
        match: false,
        message: 'Does not match',
        ...options
    };
    const {regexp} = options;
    let [all, match=options.match, bre, flags=options.flags] = /^(\!)?\/(.*)\/([gimuy])?$/.exec(regexp);
    if (match === '!') {
        match = false;
    }
    const re = new RegExp(bre, flags);

    return function regexp$validator(value) {
        //Don't check empty values (add a 'required' validator for validators)
        if (value == null || value === '') return;

        //Create RegExp from string if it's valid
        if ((match) ? re.test(value) : !re.test(value)) {
            return {
                type: options.type,
                level: options.level,
                message: options.message
            };
        }
    };
};


/** WEBPACK FOOTER **
 ** ./src/validators/regexp.js
 **/